import {Typography} from "@material-ui/core";
import {Record} from "ra-core";
import {FieldProps, FunctionField, useRecordContext} from "react-admin";
import {getUser} from "../../authProvider";
import {CarrierField} from "../../components/CarrierField";
import {DriverField} from "../../components/DriverField";
import {useMemo, useState} from "react";

export const DriverCarrierField = (
    props: FieldProps & { source?: string, forceTypografy?: boolean }
) => {
    const record = useRecordContext(props);
    const user = getUser();

    return record ? (
        <FunctionField
            record={record}
            render={(r: Record | undefined) => {
                if (r){
                    if (props.source){
                        if (r[props.source]){
                            return (
                                r[props.source].driver ? (((
                                            (new Date(r[props.source].planned_date).getTime() - new Date().getTime()) / 3600000 < 1.5) ||
                                        user.permissions.includes("distribution.change_route") &&
                                        user.permissions.includes("employees.view_employee")
                                    ) ? (
                                        props.forceTypografy ? (
                                            <Typography>{r[props.source].driver.surname + " " + r[props.source].driver.name}</Typography>
                                        ) : (
                                            <DriverField record={r[props.source]} source="driver" label={"Autista"} />)
                                    ) : (
                                        <Typography style={{
                                            filter: "blur(4px)",
                                        }}>E' colpa di Be20</Typography>))
                                    : (
                                        props.forceTypografy ? (
                                            <Typography>{r[props.source].carrier.business_name}</Typography>
                                        ) : (
                                            <CarrierField record={r[props.source]} source="carrier" label={"Vettore"} />
                                        )
                                    )
                            )
                        }
                    }
                    else {
                        return (
                            r.driver ? (((
                                        (new Date(r.planned_date).getTime() - new Date().getTime()) / 3600000 < 1.5) ||
                                    user.permissions.includes("distribution.change_route") &&
                                    user.permissions.includes("employees.view_employee")
                                ) ? (
                                    props.forceTypografy ? (
                                        <Typography>{r.driver.surname + " " + r.driver.name}</Typography>
                                    ) : (
                                        <DriverField source="driver" label={"Autista"} />)
                                ) : (
                                    <Typography style={{
                                        filter: "blur(4px)",
                                    }}>E' colpa di Be20</Typography>))
                                : (
                                    props.forceTypografy ? (
                                        <Typography>{r.carrier.business_name}</Typography>
                                    ) : (
                                        <CarrierField source="carrier" label={"Vettore"} />
                                    )
                                )
                        )
                    }

                }
                return null

            }
            }
        />

    ) : null;
};
